import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';
import {
  safeStringify,
  wrapWithEventPropertiesPrefix,
} from '@adsk/exo-skeleton-api/internal';

type UNKNOWN_RECORD_TYPE = Record<string, unknown>;

export interface DynatraceAPI {
  sendEvent: (event: UNKNOWN_RECORD_TYPE) => void;
  addEventModifier: (
    eventModifier: (
      event: UNKNOWN_RECORD_TYPE,
      context: UNKNOWN_RECORD_TYPE,
    ) => UNKNOWN_RECORD_TYPE,
  ) => void;
  identifyUser: (id: string) => void;
}

export function setDynatraceUser(analyticsId?: string) {
  if (!window.dynatrace) {
    const message =
      'Tried to authenticate Dynatrace with user before Dynatrace was initialized';
    report({
      scope: 'ACCExoSkeleton',
      type: REPORT_TYPES.error,
      value: message,
      context: {
        analyticsId,
        ...wrapWithEventPropertiesPrefix({
          data: safeStringify({
            analyticsId,
          }),
          message,
          type: REPORT_TYPES.error,
        }),
      },
    });
    return;
  }

  if (!analyticsId) {
    const message = 'Tried to authenticate Dynatrace with empty analyticsId';
    report({
      scope: 'ACCExoSkeleton',
      type: REPORT_TYPES.error,
      value: message,
      context: {
        analyticsId: '',
        ...wrapWithEventPropertiesPrefix({
          data: safeStringify({
            analyticsId: '',
          }),
          message,
          type: REPORT_TYPES.error,
        }),
      },
    });
    return;
  }

  window.dynatrace.identifyUser(analyticsId);
}
